module.exports = __webpack_public_path__ + "static/img/dae.ee5b65b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/dae.png
// module id = 2r/d
// module chunks = 53